import {IMatrices} from "../_interfaces/IMatrices";

export const matrices:IMatrices = {
    "Standardmatrix": {tot: 10, can_hold_thread: false, splittable: true, split: false},
    "Erweiterte Matrix": {tot: 15, can_hold_thread: true, splittable: true, split: false},
    "Gepanzerte Matrix": {tot: 25, can_hold_thread: true, splittable: true, split: false},
    "Summenmatrix": {tot: 20, can_hold_thread: false, splittable: false, split: false},
}